module.exports = __webpack_public_path__ + "4a020ef57fd7197bca239264cd2f90fb.png";